import { Info } from './Info'
import { Map } from './Map'

export const Component = { Map, Info }
